import React from 'react';

import ProductsContextProvider from '@/common/contexts/ProductsContext/ProductsContext';
import { ProductsFiltersContextProvider } from '@/common/contexts/ProductsFilters';

import {
  ProductsLayoutDefaultProps,
  ProductsLayoutPropTypes,
} from './ProductsLayout.proptypes';

const ProductsLayout = ({ children, pageName }) => (
  <ProductsContextProvider pageName={pageName} withPricesAndStocks>
    <ProductsFiltersContextProvider>{children}</ProductsFiltersContextProvider>
  </ProductsContextProvider>
);

ProductsLayout.defaultProps = {
  ...ProductsLayoutDefaultProps,
};

ProductsLayout.propTypes = {
  ...ProductsLayoutPropTypes,
};

export default ProductsLayout;
